/**
 * i18n path constants — inlined to avoid circular build dependency
 * between shared-translations and shared-configuration.
 * Source of truth: Configuration class in shared-configuration.
 */
const I18N_PREFIX = 'assets/i18n';
const I18N_FILE_EXTENSION = 'json';
const CORE_TRANSLATIONS = 'core';

export class TranslationLoaderHelper {
  private static MODULE_PLACEHOLDER = '_MODULE_NAME_';
  private static LANGUAGE_PLACEHOLDER = '_LANGUAGE_';
  private static BUILD_TIME = '_BUILD_TIME_';

  private static MODULE_i18n_PATH = `${I18N_PREFIX}/${TranslationLoaderHelper.MODULE_PLACEHOLDER}/${TranslationLoaderHelper.LANGUAGE_PLACEHOLDER}.${I18N_FILE_EXTENSION}?v=${TranslationLoaderHelper.BUILD_TIME}`;
  private static COMMON_i18n_PATH = `${I18N_PREFIX}/${CORE_TRANSLATIONS}/${TranslationLoaderHelper.LANGUAGE_PLACEHOLDER}.${I18N_FILE_EXTENSION}?v=${TranslationLoaderHelper.BUILD_TIME}`;

  public static createModuleI18nPath(
    moduleName: string,
    language: string,
    buildTime: string
  ): string {
    return TranslationLoaderHelper.MODULE_i18n_PATH.replace(
      TranslationLoaderHelper.MODULE_PLACEHOLDER,
      moduleName
    )
      .replace(TranslationLoaderHelper.LANGUAGE_PLACEHOLDER, language)
      .replace(TranslationLoaderHelper.BUILD_TIME, buildTime);
  }

  public static createCommonI18nPath(language: string, buildTime: string): string {
    return TranslationLoaderHelper.COMMON_i18n_PATH.replace(
      TranslationLoaderHelper.LANGUAGE_PLACEHOLDER,
      language
    ).replace(TranslationLoaderHelper.LANGUAGE_PLACEHOLDER, language)
      .replace(TranslationLoaderHelper.BUILD_TIME, buildTime);
  }
}
